import moment from 'moment'
import { StatusView, SubscriptionStatus } from 'src/models/organizations.models'

// Returns the end-of-paid-period date as a moment, or null. The relevant
// date varies by status — ACTIVE carries nextBillingAt, NON_RENEWING carries
// cancelsAt, IN_TRIAL carries trialEnd. Returns null for the other statuses
// (FUTURE / PAUSED / CANCELLED) so callers fall back to generic copy.
function deriveBillingCycleEndMoment(
  state: StatusView | undefined,
): moment.Moment | null {
  if (!state) return null
  switch (state.status) {
    case SubscriptionStatus.ACTIVE:
      return moment(state.nextBillingAt)
    case SubscriptionStatus.NON_RENEWING:
      return moment(state.cancelsAt)
    case SubscriptionStatus.IN_TRIAL:
      return moment(state.trialEnd)
    default:
      return null
  }
}

// Full date for top copy + the deactivation notice, e.g. "May 31, 2026".
export function deriveBillingCycleEnd(
  state: StatusView | undefined,
): string | null {
  const date = deriveBillingCycleEndMoment(state)
  return date ? date.format('MMMM D, YYYY') : null
}

// Short date for the over-limit count label, e.g. "May 31".
export function deriveBillingCycleEndShort(
  state: StatusView | undefined,
): string | null {
  const date = deriveBillingCycleEndMoment(state)
  return date ? date.format('MMMM D') : null
}
